/** InsCoder WANG.J 2026-05-27 B + Lazy load header navigation menu content **/
(function () {
  var lazyMenuDocumentPromise = null;

  function getHeaderWrapper() {
    return document.querySelector('.header-wrapper[data-section-id]');
  }

  function setStatus(target, message, isLoading) {
    if (!target) {
      return;
    }

    var status = target.querySelector('.header-lazy-menu__status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'header-lazy-menu__status';
      target.appendChild(status);
    }

    status.textContent = message || '';
    status.classList.toggle('header-lazy-menu__status--loading', Boolean(message) && isLoading === true);
  }

  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function buildLazyMenuUrl() {
    var url = new URL(window.location.href);
    var rootPath = '/';

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      rootPath = window.Shopify.routes.root;
    }

    if (rootPath.charAt(rootPath.length - 1) !== '/') {
      rootPath += '/';
    }

    url.pathname = rootPath + 'search';
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.searchParams.set('view', 'header-lazy-menu');

    return url.toString();
  }

  async function fetchLazyMenuDocument() {
    if (lazyMenuDocumentPromise) {
      return lazyMenuDocumentPromise;
    }

    lazyMenuDocumentPromise = fetch(buildLazyMenuUrl(), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to fetch header menu content');
      }

      return response.text();
    }).then(function (text) {
      var parser = new DOMParser();
      var documentFragment = parser.parseFromString(text, 'text/html');

      if (!documentFragment.querySelector('.header-lazy-menu-response')) {
        throw new Error('Empty header menu content');
      }

      return documentFragment;
    }).catch(function (error) {
      lazyMenuDocumentPromise = null;
      throw error;
    });

    return lazyMenuDocumentPromise;
  }

  /** InsCoder WANG.J 2026-05-28 B + Initialize promo block slider for initial and lazy header content **/
  function initializePromoBlockSlider(scope) {
    if (!scope || typeof Swiper === 'undefined') {
      return;
    }

    var promoSlider = scope.querySelector('.promo-block-slider');
    if (!promoSlider || promoSlider.dataset.lazySwiperInitialized === 'true') {
      return;
    }

    var promoContainer = promoSlider.closest('.promo-block-container') || scope.querySelector('.promo-block-container');
    if (!promoContainer) {
      return;
    }

    var promoSlides = promoSlider.querySelectorAll('.swiper-slide');
    var slideCount = promoSlides.length;
    var nextButton = promoContainer.querySelector('.swiper-button-next');
    var prevButton = promoContainer.querySelector('.swiper-button-prev');
    var highlightContainer = promoContainer.querySelector('.highlight-container');

    if (promoContainer.classList.contains('slideline-test') && !highlightContainer) {
      highlightContainer = document.createElement('div');
      highlightContainer.className = 'highlight-container';
      highlightContainer.innerHTML = '<div class="highlight"></div>';
      promoContainer.appendChild(highlightContainer);
    }

    function updateHighlight(activeIndex) {
      if (!highlightContainer || slideCount <= 0) {
        return;
      }

      var highlight = highlightContainer.querySelector('.highlight');
      if (!highlight) {
        return;
      }

      var containerWidth = highlightContainer.offsetWidth;
      var highlightWidth = containerWidth / slideCount;
      highlight.style.width = highlightWidth + 'px';
      highlight.style.transform = 'translateX(' + (highlightWidth * activeIndex) + 'px)';
    }

    new Swiper(promoSlider, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        slideChange: function () {
          updateHighlight(this.realIndex);
        },
        init: function () {
          updateHighlight(0);
        }
      }
    });

    promoSlider.dataset.lazySwiperInitialized = 'true';
  }
  /** InsCoder WANG.J 2026-05-28 E + Initialize promo block slider for initial and lazy header content **/

  async function ensureLazyMenuContent(mode, target) {
    if (!target || target.dataset.loaded === 'true' || target.dataset.loading === 'true') {
      return;
    }

    var menuKey = target.dataset.menuKey;
    if (!menuKey) {
      return;
    }

    target.dataset.loading = 'true';
    setStatus(target, 'Loading...', true);

    try {
      var lazyDocument = await fetchLazyMenuDocument();
      var selector = '[data-menu-mode="' + mode + '"][data-menu-key="' + escapeSelectorValue(menuKey) + '"]';
      var content = lazyDocument.querySelector(selector);

      if (!content) {
        throw new Error('Missing lazy menu node');
      }

      target.innerHTML = content.innerHTML;
      target.dataset.loaded = 'true';
      target.dataset.loading = 'false';
      setStatus(target, '', false);

      if (mode == 'mobile') {
        removeDuplicateMobileProducts(target.closest('.second-btn-menu'));
        bindAccordionDetails(target);
      } else if (mode == 'desktop') {
        initializePromoBlockSlider(target);
      }
    } catch (error) {
      target.dataset.loading = 'false';
      setStatus(target, 'Unable to load menu right now.', false);
    }
  }

  function preloadLazyMenusAfterRender(desktopMenus, secondBtnmenu) {
    var headerWrapper = getHeaderWrapper();
    if (!headerWrapper) {
      return;
    }

    secondBtnmenu.forEach(function (menu) {
      var mobileTarget = menu.querySelector('.menu-drawer__inner-submenu[data-menu-mode="mobile"]');
      ensureLazyMenuContent('mobile', mobileTarget);
    });

    desktopMenus.forEach(function (menu) {
      var desktopTarget = menu.querySelector('.header__megamenu-content[data-menu-mode="desktop"]');
      ensureLazyMenuContent('desktop', desktopTarget);
    });
  }

  function removeDuplicateMobileProducts(container) {
    if (!container) {
      return;
    }

    var productElements = container.querySelectorAll('.second-menu__collection');
    var seenIds = new Set();

    productElements.forEach(function (element) {
      var productId = element.getAttribute('data-proid');

      if (seenIds.has(productId)) {
        element.style.display = 'none';
      } else {
        seenIds.add(productId);
      }
    });
  }

  function bindAccordionDetails(scope) {
    var detailsElements = (scope || document).querySelectorAll('.third-grand-titledt');

    detailsElements.forEach(function (details) {
      if (details.dataset.lazyBound === 'true') {
        return;
      }

      details.dataset.lazyBound = 'true';

      var summary = details.querySelector('summary');
      if (!summary) {
        return;
      }

      summary.setAttribute('aria-expanded', details.hasAttribute('open'));

      details.addEventListener('toggle', function () {
        var isOpen = this.hasAttribute('open');
        var currentSummary = this.querySelector('summary');
        var siblingDetails = this.parentElement ? this.parentElement.querySelectorAll('.third-grand-titledt') : [];

        if (isOpen) {
          siblingDetails.forEach(function (otherDetails) {
            if (otherDetails !== details && otherDetails.hasAttribute('open')) {
              otherDetails.removeAttribute('open');
              var otherSummary = otherDetails.querySelector('summary');
              if (otherSummary) {
                otherSummary.setAttribute('aria-expanded', 'false');
              }
            }
          });
          currentSummary.setAttribute('aria-expanded', 'true');
        } else {
          currentSummary.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function updateAnnouncementBarScrollHeight(announcementBar) {
    var announcementBarHeight = announcementBar.offsetHeight;
    var scrollDistance = window.scrollY;

    if (scrollDistance >= announcementBarHeight) {
      document.documentElement.style.setProperty('--announcement-bar-scroll-height', '0px');
    } else {
      var remainingHeight = announcementBarHeight - scrollDistance;
      document.documentElement.style.setProperty('--announcement-bar-scroll-height', remainingHeight + 'px');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var openHambage = document.querySelector('.icon-hamburger');
    var span = openHambage ? openHambage.parentElement : null;
    var menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    var announcementBar = document.querySelector('.shopify-section-announcement-bar');
    var headericonAccount = document.querySelector('.header__icon--account');
    var headericonCart = document.querySelector('.header__icon--cart');
    var headerLogo = document.querySelector('.header__heading');
    var firstBtntitle = document.querySelectorAll('.first-btn-title');
    var secondBtnmenu = document.querySelectorAll('.second-btn-menu');
    var returnfsBtn = document.querySelectorAll('.nav-second-menu svg');
    var headerSearch = document.querySelectorAll('.header__search');
    var menuDrawer = document.querySelector('.menu-drawer__navigation');
    var menuDrawerMenu = document.querySelector('.menu-drawer__menu');
    var desktopMenus = document.querySelectorAll('.header__megamenu[data-menu-key]');

    bindAccordionDetails(document);
    initializePromoBlockSlider(document);

    /** InsCoder WANG.J 2026-05-29 B + Sync mobile menu UI with native details disclosure state **/
    function syncMobileMenuState(isOpen) {
      if (isOpen) {
        document.body.classList.add('mobile-menu-open');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        if (headericonAccount) {
          headericonAccount.style.opacity = '0';
          headericonAccount.style.pointerEvents = 'none';
        }
        if (headericonCart) {
          headericonCart.style.opacity = '0';
          headericonCart.style.pointerEvents = 'none';
        }
        if (headerLogo) {
          headerLogo.style.opacity = '0';
          headerLogo.style.pointerEvents = 'none';
        }
        headerSearch.forEach(function (element) {
          element.style.opacity = '0';
          element.style.pointerEvents = 'none';
        });
        return;
      }

      document.body.classList.remove('mobile-menu-open');
      if (announcementBar) {
        announcementBar.style.display = 'block';
      }
      if (headericonAccount) {
        headericonAccount.style.opacity = '1';
        headericonAccount.style.pointerEvents = 'all';
      }
      if (headericonCart) {
        headericonCart.style.opacity = '1';
        headericonCart.style.pointerEvents = 'all';
      }
      if (headerLogo) {
        headerLogo.style.opacity = '1';
        headerLogo.style.pointerEvents = 'all';
      }
      headerSearch.forEach(function (element) {
        element.style.opacity = '1';
        element.style.pointerEvents = 'all';
      });
      secondBtnmenu.forEach(function (menu) {
        menu.style.left = '100vw';
        menu.classList.remove('open');
      });
    }
    /** InsCoder WANG.J 2026-05-29 E + Sync mobile menu UI with native details disclosure state **/

    if (announcementBar) {
      updateAnnouncementBarScrollHeight(announcementBar);
      window.addEventListener('scroll', function () {
        updateAnnouncementBarScrollHeight(announcementBar);
      });
    }

    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener('toggle', function () {
        syncMobileMenuState(this.open);
      });

      syncMobileMenuState(menuDrawerDetails.open);
    }

    if (menuDrawer && span) {
      menuDrawer.addEventListener('click', function () {
        span.click();
      });
    }

    if (menuDrawerMenu) {
      menuDrawerMenu.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    firstBtntitle.forEach(function (btn, index) {
      btn.addEventListener('click', async function (event) {
        event.stopPropagation();

        secondBtnmenu.forEach(function (menu) {
          menu.style.opacity = '0';
          menu.style.left = '100vw';
          menu.style.transition = 'all 0.7s';
          menu.classList.remove('open');
        });

        var currentMenu = secondBtnmenu[index];
        if (!currentMenu) {
          return;
        }

        currentMenu.style.transition = 'all 0.7s';
        currentMenu.style.opacity = '1';
        currentMenu.style.left = '0vw';
        currentMenu.classList.add('open');
        removeDuplicateMobileProducts(currentMenu);
      });
    });

    returnfsBtn.forEach(function (btn, index) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        if (secondBtnmenu[index]) {
          secondBtnmenu[index].style.left = '100vw';
          secondBtnmenu[index].classList.remove('open');
        }
      });
    });

    desktopMenus.forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        if (!this.hasAttribute('open')) {
          return;
        }
      });
    });

    /** InsCoder WANG.J 2026-05-28 B + Preload header lazy menus right after initial render **/
    preloadLazyMenusAfterRender(desktopMenus, secondBtnmenu);
    /** InsCoder WANG.J 2026-05-28 E + Preload header lazy menus right after initial render **/
  });
})();
/** InsCoder WANG.J 2026-05-27 E + Lazy load header navigation menu content **/
